<template>
    <div class="desktop-nav fixed top-0 left-0 h-screen m-0 flex flex-col bg-sidebar text-sidebar-foreground z-50">
        <RouterLink to="/" class="brand"><Spade class="brand-mark size-8 fill-current" aria-hidden="true" /><span>belot<span class="brand-light">masters</span></span></RouterLink>
        <NavigationContent />
    </div>
</template>

<script setup lang="ts">
import { Spade } from "lucide-vue-next";
import NavigationContent from "./NavigationContent.vue";
</script>
